// components/AirdropNotifyRowAction.js
import React, { useState } from "react";
import swal from "sweetalert";
import { apiService } from "../../service/api.service"; // adjust path
import {
    Col,
    Container,
    Row,
    Table,
    Button,
    Modal,
    Form,
    OverlayTrigger,
    Tooltip,
  } from "react-bootstrap";
export default function AirdropNotifyRowAction({ user,mode }) {
    console.log("===user===",user)
    const [showNotifyModal, setShowNotifyModal] = useState(false);
    const [Notifyemail, setNotifyEmail] = useState(user.phone_or_email);      // prefill with row user email if you have it
    const [subject, setSubject] = useState("");      // prefill with row user email if you have it
    const [userId, setuserId] = useState(user._id);      // prefill with row user email if you have it
    const [desc, setDesc] = useState("");
    const [notifyErr, setNotify] = useState({ email: "", desc: "" });
    const [sendingNotify, setSending] = useState(false);
    
    // optional: simple email check
    const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());

  const handleSendNotification = async (Notifyemail) => {
    console.log("====user====",user)
    const trimmedEmail = (Notifyemail || "").trim();
    const message = desc; // send exactly as typed (HTML allowed)
     console.log("====email====",Notifyemail)
    // if (!isEmail(trimmedEmail)) {
    //   swal("Invalid email", "Please enter a valid email address.", "warning");
    //   return;
    // }
    if (!message) {
      swal("Empty description", "Please enter a notification description.", "warning");
      return;
    }

    try {
      setSending(true);
    
      const { data } = await apiService.sendairdropNotification({
        email: isEmail(user.phone_or_email)?user.phone_or_email:"",
        description: message, // sent as HTML
        userId:user?._id,
        subject:subject,
        mode:mode,
      });

      if (data?.success) {
        swal("Sent", "Notification sent successfully.", "success");
        setShowNotifyModal(false);
        setDesc("");
      } else {
        swal("Error", data?.message || "Failed to send notification.", "error");
      }
    } catch (e) {
      console.error(e);
      swal("Error", "Something went wrong while sending.", "error");
    } finally {
      setSending(false);
    }
  };

  return (
    <div>
        {mode == "All"?
         <Button
         size="sm"
        type="buttton" variant="unset"
         onClick={() => {
           setNotifyEmail(user.email || ""); // prefill from row
           setShowNotifyModal(true);
         }}
       >
         Send notification to all
       </Button>:
    <Button
  size="sm"
  variant="outline-primary"
  onClick={() => {
    setNotifyEmail(user.email || ""); // prefill from row
    setShowNotifyModal(true);
  }}
>
  Send notification
</Button>}




 
      <Modal show={showNotifyModal} onHide={() => setShowNotifyModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Send Notification</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {mode != "All"?
    <Form.Group controlId="notifyEmail" className="mb-3">
      <Form.Label>Email address</Form.Label>
      <Form.Control
        type="email"
        placeholder="user@example.com"
        disabled={true}
        value={ isEmail(user.phone_or_email)?user.phone_or_email:""}
        onChange={(e) => setNotifyEmail(e.target.value)}
      />
      {notifyErr.email && <div className="text-danger mt-1">{notifyErr.email}</div>}
    </Form.Group>:<></>}
    <Form.Group controlId="notifyEmail" className="mb-3">
      <Form.Label>Subject</Form.Label>
      <Form.Control
        type="text"
        placeholder="Folio Ntification"
  
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
      />
      {notifyErr.email && <div className="text-danger mt-1">{notifyErr.email}</div>}
    </Form.Group>

    <Form.Group controlId="notifyDesc" className="mb-2">
      <Form.Label>
        Notification description
        <small className="text-muted ms-2">
          (Sent exactly as typed. You can use HTML like &lt;b&gt;, &lt;i&gt;, &lt;a&gt;…)
        </small>
      </Form.Label>
      <Form.Control
        as="textarea"
        rows={5}
        placeholder={`e.g. <b>Hello John</b>,\nYou’re eligible for the airdrop. <a href="https://…">Claim here</a>`}
        value={desc}
        onChange={(e) => setDesc(e.target.value)}
      />
      {notifyErr.desc && <div className="text-danger mt-1">{notifyErr.desc}</div>}
    </Form.Group>

    <small className="text-muted d-block">
      Note: There’s no auto-merge. If you want the username in the message, type it manually.
    </small>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowNotifyModal(false)}>
      Cancel
    </Button>
    <Button variant="primary" onClick={()=>handleSendNotification(Notifyemail)} disabled={sendingNotify}>
      {sendingNotify ? "Sending…" : "Send"}
    </Button>
  </Modal.Footer>
</Modal>
     
    </div>
  );
}
